export default function safeQuerySelector(selector, element) {
    if (element === void 0) { element = document; }
    try {
        return element.querySelector(selector);
    }
    catch (e) {
        console.warn("Error querying selector: ".concat(selector));
        return null;
    }
}
